import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Skill } from '@freelancer/datastore/collections';
import { Margin } from '@freelancer/ui/margin';

@Component({
  selector: 'app-suggested-skills',
  template: `
    <fl-bit class="SuggestedSkillsContainer" [flMarginBottom]="Margin.LARGE">
      <ng-container *ngIf="skills && skills.length > 0">
        <fl-label
          i18n="Suggested skills label"
          [flMarginRight]="Margin.XXXSMALL"
        >
          Suggested skills:
        </fl-label>

        <fl-bit
          *ngFor="let skill of skills; let isLast = last"
          [flMarginRight]="Margin.XXXSMALL"
        >
          <fl-link
            flTrackingLabel="SelectSuggestedSkill"
            flTrackingReferenceType="skill_id"
            [flTrackingExtraParams]="{ skill_name: skill.name }"
            [flTrackingReferenceId]="skill.id"
            (click)="skillClick.emit(skill)"
          >
            {{ skill.name }} </fl-link
          >{{ isLast ? '' : ',' }}
        </fl-bit>
      </ng-container>
    </fl-bit>
  `,
  styleUrls: ['suggested-skills.component.scss'],
})
export class SuggestedSkillsComponent {
  Margin = Margin;

  @Input() skills: ReadonlyArray<Skill>;

  @Output() skillClick = new EventEmitter();
}
